"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z
    .object({
    regions: zod_1.z.object({
        regionIds: zod_1.z.array(zod_1.z.string()).nonempty(),
        _metaData: zod_1.z.object({
            geometry: zod_1.z.boolean(),
        }),
    }),
})
    .refine((args) => !!Object.keys(args).length, { message: 'Must request at least one type of field asset' });
exports.path = '/landing-page-field-asset-configurations';
//# sourceMappingURL=index.js.map